module.exports = __webpack_public_path__ + "img/success.e9c3d38a.png";